module.exports = __webpack_public_path__ + "img/23.398f9693.png";